<template>
  <v-dialog v-model="dialog" persistent max-width="450">
    <template v-slot:activator="{ on, attrs }">
      <!-- <v-btn fab small dark color="primary" v-bind="attrs" v-on="on">
            <v-icon>mdi-plus</v-icon>
          </v-btn> -->
      <v-btn rounded v-if="appbar" small dark v-bind="attrs" v-on="on" outlined>ADD TIME</v-btn>
      <v-btn rounded v-else small dark v-bind="attrs" v-on="on" color="primary">ADD TIME</v-btn>

    </template>

    <v-card>
      <v-card-title class="text-h5">Add Time </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-5">
        <v-row>
          <v-col>
            <div>Select Employee</div>
            <v-select label="Select Employee" :items="employees" v-model="selectedEmployee" item-text="name" hide-details
              return-object outlined solo dense :loading="employees.length === 0"></v-select>
          </v-col>
          <v-col cols="12" v-if="timeClock.clockInTime">
            <div>Clock In</div>
            <DateTimeTextField v-model="timeClock.clockInTime" :initDate="timeClock.clockInTime" />
          </v-col>
          <v-col cols="12" v-if="timeClock.clockOutTime">
            <div>Clock Out</div>
            <DateTimeTextField v-model="timeClock.clockOutTime" :initDate="timeClock.clockOutTime" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text>
        {{ secondsToHms(totalSeconds) }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="red darken-1" text @click="close"> Close </v-btn>
        <v-btn color="green darken-1" :disabled="!selectedEmployee" text @click="submit" :loading="loading">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import timeClockService from "@/modules/TimeClock/service";
import DateTimeTextField from "@/components/DateTimeTextField.vue";
import employeeService from "@/modules/Employee/service";

export default {
  props: ["employee", 'appbar'],
  data: (vm) => ({
    selectedEmployee: null,
    dialog: false,
    loading: false,
    totalSeconds: 0,
    employees: [],
    timeClock: {
      clockInTime: vm.$moment(),
      clockOutTime: vm.$moment(),
      status: "clockedOut",
    },
  }),
  components: {
    DateTimeTextField,
  },
  watch: {
    timeClock: {
      handler(val) {
        let date1 = new Date(val.clockInTime);
        let date2 = new Date(val.clockOutTime);

        this.totalSeconds = Math.abs(date1 - date2) / 1000;
      },
      deep: true,
    },
    dialog(val) {
      if (val) {
        // this.timeClock.EmployeeId = this.employee.id;
        // this.timeClock.LocationId =
        //   this.employee.LocationEmployees[0].LocationId;
        // this.timeClock.OrganizationId = this.employee.OrganizationId;
        // this.timeClock.status = "clockedOut";
        this.loadEmployees();
      }
      console.log("watch", this.employee, this.timeClock);
    },
  },
  methods: {
    loadEmployees() {
      employeeService
        .getAll({
          limit: 100,
        })
        .then((response) => {
          console.log("response", response);
          this.employees = response.data;
          if (this.employee) {
            this.employees.map((row) => {
              if (row.id === this.employee.id) this.selectedEmployee = row;
            });
          }

          // const selectedEmployee = this.employees.filter(employee => employee.id = this.employee.id)
          console.log("empllddf", this.selectedEmployee);
        })
        .catch((error) => {
          throw error;
        });
    },
    reset() {
      this.timeClock = {
        clockInTime: this.$moment(),
        clockOutTime: this.$moment(),
        status: "clockedOut",
      };
    },
    close() {
      this.reset();
      this.dialog = false;
    },
    secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);

      var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
      return hDisplay + mDisplay + sDisplay;
    },
    submit() {
      this.loading = true;
      this.timeClock.EmployeeId = this.selectedEmployee.id;

      timeClockService
        .create(this.timeClock)
        .then(() => {
          this.dialog = false;
          this.$emit("submit");
          this.loading = false;
        })
        .catch((err) => {
          this.$emit("error", err);
          this.loading = false;
          // console.log("err :: ", err);
        });
    },
  },
};
</script>

<style scoped></style>